export var IconTypes = /*#__PURE__*/function (IconTypes) {
  IconTypes["strong"] = "strong";
  IconTypes["em"] = "em";
  IconTypes["underline"] = "underline";
  IconTypes["strike"] = "strike";
  IconTypes["code"] = "code";
  IconTypes["subscript"] = "subscript";
  IconTypes["superscript"] = "superscript";
  return IconTypes;
}({});
export var FormatOptions = /*#__PURE__*/function (FormatOptions) {
  FormatOptions["strong"] = "strong";
  FormatOptions["em"] = "em";
  FormatOptions["underline"] = "underline";
  FormatOptions["strike"] = "strike";
  FormatOptions["code"] = "code";
  FormatOptions["subscript"] = "subscript";
  FormatOptions["superscript"] = "superscript";
  return FormatOptions;
}({});
export var ToolbarType = /*#__PURE__*/function (ToolbarType) {
  ToolbarType["PRIMARY"] = "primaryToolbar";
  ToolbarType["FLOATING"] = "floatingToolbar";
  return ToolbarType;
}({});